export const PATH_URL = {
  HOME: '/',
  LOGIN: '/user/login',
  SIGNUP: '/user/signup',
  BOARD: '/boards',
  POST: '/boards/:boardId',
  CREATE: '/boards/create',
};
